import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { AnalyticsDetailsRoute } from "./routes";
export default store => {
  return {
    path: "custom-reports",
    component: withAsyncRouteLoading(() => {
      return Promise.all([
        import(/* webpackChunkName: "school-analytics" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      });
      //.catch(err => {
      // throw err;
      // });
    }),
    childRoutes: [AnalyticsDetailsRoute(store)],
  };
};
